export default __webpack_public_path__ + "static/media/setupShopify_2.00c6ca64.png";